export const PAGE_URL = {
    ROOT_PAGE : '/',
    PAGE_NOT_FOUND : '/page-not-found',
    NO_PERMISSION: '/no-permission-route',
    CREATE_ZONE_URL: '/manage-zones/create-zone',
    ZONE_EDITOR_URL: '/manage-zones/zone-editor',
  };
